import { Faq } from "./style";
import { FiArrowUpRight } from "react-icons/fi";

function FaqComponent() {
  const db = [
    {
      withLink: true,
      title: "É realmente possível aprender inglês em até 8 meses?",
      description:
        "Dentro da minha experiência em 40 anos de carreira como professor, tive contato com milhares de clientes, que em sua grande maioria traziam suas frustrações, dúvidas e dificuldades no aprendizado de inglês, sem resultado algum. Com isso, me aprofundei em COMPORTAMENTO HUMANO e, assim foi possível a criação do Processo Comportamental©, desenvolvido para trazer o resultado desejado. Sim, em até 8 meses.",
      link: "https://www.flavio-moura.com/programa-de-idiomas",
    },
    {
      withLink: true,
      title: "Como você explica todo esse ganho de investimento e tempo?",
      description:
        "A partir do momento que passamos a nos conhecer, sabemos de nossas fraquezas e fortalezas, podemos decidir, através de um planejamento, o que estou disposto(a) a fazer e, com isso, chegar ao resultado muito mais rápido. Tudo isso é obtido através da execução do Processo Comportamental® e suas revisões.",
      link: "https://www.flavio-moura.com/artigo/revolucao-na-comunicacao-natural",
    },
    {
      withLink: true,
      title: `O que é o Processo Comportamental©?`,
      description: `O Processo Comportamental© é o caminho que faremos juntos. Ele mostra o
      "COMO", COMO fazer e COMO atingir o resultado. Ele foi desenvolvido para que saibamos onde estamos, onde queremos chegar e o que é preciso fazer para se chegar ao resultado.`,
      link: "https://www.flavio-moura.com/artigo/processo-comportamental",
    },
    {
      withLink: true,
      title: "Eu vou ficar fluente em inglês?",
      description: `Eu, particularmente, tenho uma enorme RESTRIÇÃO a essa palavra - fluência - simplesmente porque ela é abstrata. E, justamente por eu ser intérprete, vejo que ela abre uma margem muito grande de interpretação. Dito isso, eu lhe digo, você vai se comunicar em inglês - "se fazer entender e ser entendido." Além do que, um dos bônus que você vai receber com esse curso será das técnicas para a quebra de bloqueios e traumas que trazem essa noção de fluência. Vou deixar um link no botão abaixo que traz umas dicas de ouro. Aproveite!`,
      link: "https://www.flavio-moura.com/artigo/7-dicas-para-perder-o-medo-de-falar-ingles-em-publico",
    },
    {
      withLink: true,
      title: "Eu tenho nível mais avançado de inglês, esse curso é para mim?",
      description:
        "Se você está buscando um Programa de Inglês é porque sente a necessidade de aprender mais, conhecer mais, falar mais, entender mais. Então sim, esse curso é para você! Vou deixar uma ótima leitura no botão abaixo. Não esqueça de deixar seu comentário, okay?",
      link: "https://www.flavio-moura.com/artigo/a-importancia-de-entendermos-como-aprendemos-ingles",
    },
    {
      withLink: true,
      title: "O curso tem GARANTIA?",
      description: `Como eu costumo dizer, "Eu garanto o resultado, e você?"
      Você vai usar as 4 habilidades (fala, escuta, leitura e audição) de maneira que possa se comunicar em inglês com naturalidade, em até 160 horas.
      A garantia se dá dentro dos dados e resultados obtidos nos últimos 13 anos. Esse resultado será obtido certamente ao se aplicar todo o diferencial, em sua totalidade.
      Pense muito bem e tire todas as suas dúvidas, pois após começado o programa não há a possibilidade de cancelamento, visto que há uma série de ferramentas que são aplicadas no planejamento do Programa de Inglês que tem valor agregado alto.`,
      link: "https://www.youtube.com/watch?v=sxY6P29-0Rs&list=PLr46PD_N9L1jjW5jo-iuucR8-KVA_Y6lP&ab_channel=FlavioMoura",
    },
    {
      withLink: false,
      title: `Por que só tem uma aula por semana?`,
      description: `Você vai entender no início do processo a dica de ouro, que ninguém nunca te contou, "Não é o que você faz na aula que vai lhe trazer resultado, é o que você faz entre uma aula e outra." Como eu costumo dizer, a aula é a cereja do bolo, a celebração de um trabalho bem feito na semana. Lembre-se, você vai ter um acompanhamento FULL TIME para chegar ao resultado que precisa, no tempo que precisa. O que vai determinar o seu sucesso é a sua atitude, o seu comportamento.`,
    },
    {
      withLink: true,
      title: `É verdade que o mercado precisa muito pessoas que falem inglês?`,
      description: `No meu canal do YouTube, fiz uma série de Webinars falando exatamente isso com vários especialistas de diferentes áreas: RH, Recrutamento e Seleção, Comércio Exterior e Perfil Comportamental. Fica claro que quem fala inglês, ganha mais, tem mais oportunidades, tanto aqui quanto internacionalmente. Falta muito profissional com comunicação em inglês no mercado, em várias áreas. Esse é sim um diferencial ainda maior, nos dias de hoje, do que uma graduação.
      Vou deixar o link da Trilha do Conhecimento, só clicar no botão abaixo.`,
      link: "https://youtube.com/playlist?list=PLr46PD_N9L1jjW5jo-iuucR8-KVA_Y6lP&si=2UiXGchQ85jqFNWx",
    },
    {
      withLink: false,
      title: `O curso tem CERTIFICADO?`,
      description: `Sim, você receberá um certificado de conclusão e nível de proficiência atingida.
      Mas vou deixar aqui uma dica, não se apegue a isso, pois o que as empresas buscam é a aplicação do conhecimento e não no papel. E, é aí que coloco todo meu foco na condução do processo.`,
    },
  ];
  return (
    <Faq id="thefaq">
      <div id="pather-div">
        <section id="info-faq">
          <div id="div-one">
            <span id="span-faq">FAQ</span>
            <h1>Perguntas e dúvidas frequentes..</h1>
            <p>
              Caso tenha alguma pergunta que não esteja contemplada aqui, por
              favor, entre em contato comigo, através do botão{" "}
              <span>“FALAR COMIGO AGORA”</span>. Eu lhe darei todas as
              informações que precisar. Pode contar comigo!
            </p>
          </div>
          <div id="div-two">
            <button>
              <a target="blank" href="https://api.whatsapp.com/send?phone=5511940579505&text=Gostaria%20de%20falar%20sobre">Falar comigo agora <FiArrowUpRight /></a>
            </button>
          </div>
        </section>
        <section id="the-faq">
          {db.map((item) => (
            <details key={item.title}>
              <summary>
                <h3>{item.title}</h3>
              </summary>
              <p>{item.description}</p>
              {
                (item.withLink === true && (
                  <a target="blank" href={item.link}>
                    Ver mais detalhes <FiArrowUpRight />
                  </a>
                ))
              }
            </details>
          ))}
        </section>
      </div>
    </Faq>
  );
}

export default FaqComponent;
